<!--
 * @Author: zhaoliang
 * @Date: 2023-04-26 14:29:55
 * @LastEditTime: 2023-04-26 15:31:57
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/components/BaseUi/LoadingModalwithText/index.vue
 *
-->
<template>
  <div class="loading-modal" v-show="visible">
    <div class="loading-overlay"></div>
    <div class="loading-spinner">
      <img src="~img/icon-loading.svg" alt="" />
    </div>
    <div class="loading-text">
      <img src="~img/icon-lock.svg" alt="lock" />
      <p>{{ i18n.t('otp-loading-text') }}</p>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n';
  export default {
    name: 'textLoadingModal',
    data() {
      return {
        i18n,
      };
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss">
  .loading-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(22, 48, 73, 0.96);
  }

  .loading-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
  }

  .loading-spinner img {
    display: block; /* 去除默认的行内元素间隙 */
    width: 100%;
    height: 100%;
    animation: spin 1s linear infinite;
    transform-origin: 50% 50%; /* 以图片中心旋转 */
  }

  .loading-text {
    width: 500px;
    @include font(28px, 700);
    line-height: 38px;
    position: absolute;
    top: calc(50% - 180px);
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    color: #fff;
    text-align: center;

    img {
      margin-bottom: 24px;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: 1024px) {
    .loading-spinner {
      width: 80px;
      height: 80px;
    }
    .loading-text {
      width: 80%;
      line-height: 28px;
    }
  }
</style>
